var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    clipPath: "url(#clip0_1506_959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0585 5.70997C18.6685 5.31997 18.0385 5.31997 17.6485 5.70997L12.7585 10.59L7.86852 5.69997C7.47852 5.30997 6.84852 5.30997 6.45852 5.69997C6.06852 6.08997 6.06852 6.71997 6.45852 7.10997L11.3485 12L6.45852 16.89C6.06852 17.28 6.06852 17.91 6.45852 18.3C6.84852 18.69 7.47852 18.69 7.86852 18.3L12.7585 13.41L17.6485 18.3C18.0385 18.69 18.6685 18.69 19.0585 18.3C19.4485 17.91 19.4485 17.28 19.0585 16.89L14.1685 12L19.0585 7.10997C19.4385 6.72997 19.4385 6.08997 19.0585 5.70997Z",
    fill: "#000D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIc);
export default __webpack_public_path__ + "static/media/cross-ic.42a1263bc181b1c0062c1daece9e86b8.svg";
export { ForwardRef as ReactComponent };